



































import {Component, Vue} from 'vue-property-decorator';
import ItemTile from '@/components/ItemTile.vue';
import {VDivider} from 'vuetify/lib';

@Component({
	components: {
		ItemTile,
		VDivider,
	},
})
export default class Footer extends Vue {}
